import { Directive } from '@angular/core';

@Directive({
    selector: '[monTemplateRef]',
    standalone: false,
})
export class TemplateReferenceDirective {}
